module.exports = __webpack_public_path__ + "static/sand5-0279ed7730364744ae2dba5a3eae93c5.png";